import { memo, useContext } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";
import InputText from "./InputText";
import InputEmail from "./InputEmail";
import Subject from "./Subject";

const FormMain = memo(() => {
	const { inputs, setInputs, errors, setErrors } = useContext(Data);

	return (
		<div className={styles.formMain}>
			<h3 className={`en ${styles.headline}`}>
				PERSONAL<span>氏名をご入力</span>
			</h3>
			<div>
				{inputs.category !== "その他" && <Subject />}
				{inputs.subject === "ショールームについて" ? (
					<p className={styles.link}>
						ショールームのご予約は<a href="/showroom/coordinate/">こちら</a>
						から
					</p>
				) : (
					<></>
				)}
				{inputs.subject !== "法人のお客様" ? (
					<>
						<InputText
							label={"お名前"}
							name={"name"}
							max={20}
							placeholder={"ノイエス太郎"}
							require
						/>
						<InputText
							label={"ふりがな"}
							name={"furigana"}
							max={20}
							placeholder={"のいえすたろう"}
							require
						/>
						<InputEmail
							label={"メールアドレス"}
							name={"email"}
							placeholder={"noyes@ny-k.co.jp"}
							require
							check
						/>
					</>
				) : (
					<p className={styles.link}>
						法人お問い合わせフォームへご連絡ください。
						<br />
						法人お問い合わせは
						<a href="/business/">こちら</a>
						から
					</p>
				)}
			</div>
		</div>
	);
});

export default FormMain;
